import {SocialLinks} from '#/components/links/social-links';
import {useCoinDisplayPreferences} from '#/hooks/use-coin-display-preferences';
import {FunctionComponent} from 'react';
import {useTranslation} from 'react-i18next';

export const FooterNote: FunctionComponent<{showConversionNotice?: boolean; className?: string}> = ({
  showConversionNotice = true,
  className = '',
}) => {
  const {t} = useTranslation('translation');
  const displayPref = useCoinDisplayPreferences();

  return (
    <div className={`px-5 md:px-10 ${className}`}>
      {showConversionNotice && (
        <div className='mt-10 mb-3 flex justify-center text-center text-gray-400 text-xs'>
          {t('pages.home.footer.usdcUsdConversionRate', {
            usdcUsdConversionRate: displayPref.usdcValue,
          })}
        </div>
      )}
      <div className='flex justify-center gap-2 text-gray-400 text-xs'>
        <SocialLinks />
      </div>
    </div>
  );
};
